import {searchTouristRouteStops}
  from '@/api/tourist-route/tourist-route.api.js';

export default class QueryStopsTableConfig {
  constructor({
    stopId = 0,
  }) {
    const config = {
      title: 'Paradas',
      api: (async () => await searchTouristRouteStops(stopId)),
      Model: class User {
        constructor(data) {
          Object.keys(data).forEach((k) => (this[k] = data[k]));
        }
      },
      schema: [
        {
          field: 'nombre',
          label: 'Nombre',
        },
        {
          field: 'descripcion',
          label: 'Descripción',
        },
        {
          field: 'fiesta',
          label: 'Fiestas',
        },
        {
          field: 'fotoUrl',
          label: 'Foto',
          sortable: false,
        },
      ],
      actions: {
        header: [],
        item: [],
      },
      messages: {
        loading: 'Cargando resultados',
        empty: 'No hay paradas',
      },
      views: [
        {
          type: 'table',
        },
        {
          type: 'list',
        },
      ],
      behaviour: {
        useQuery: false,
      },
    };

    return config;
  }
}
